import { render, staticRenderFns } from "./Allowance.vue?vue&type=template&id=322b95f1&"
import script from "./Allowance.vue?vue&type=script&lang=js&"
export * from "./Allowance.vue?vue&type=script&lang=js&"
import style0 from "./Allowance.vue?vue&type=style&index=0&id=322b95f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports